<template>
  <m-dialog :fullscreen="false" ref="dlgSyarat" @save="save" :title="`Jenis Kelas: ` + title">
    <v-row row justify="center" align="center" class="pt-4">
      <v-card flat text class="ma-0 py-0">
        <v-card-text class="mb-0 pb-0">
          <v-form autocomplete="false" data-vv-scope="form" lazy-validation class="mx-5 mt-2 my-2">
            <v-row v-for="(s, index) in syarats" :key="s.index">
              <v-col cols="12" sm="5" md="5" lg="5" class="my-0 py-0">
                <v-select
                  id-k_syarat
                  outlined
                  dense
                  autocomplete="false"
                  v-model="s.k_syarat"
                  :items="itemSyarat"
                  item-text="nama"
                  item-value="id"
                  return-object
                  label="Jenis Syarat"
                  placeholder="Jenis Syarat"
                  @change="loadValSyarat(s.k_syarat, index)"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" class="my-0 py-0">
                <v-autocomplete
                  id="k_data"
                  outlined
                  dense
                  multiple
                  autocomplete="false"
                  v-model="s.data"
                  :disabled="s.k_syarat ? false : true"
                  :items="itemPilihanSyarat[index]"
                  item-text="keterangan"
                  item-value="value"
                  return-object
                  label="Pilih Syarat"
                  placeholder="Syarat"
                ></v-autocomplete>
              </v-col>
              <v-col v-if="syarats.length > 1" cols="12" sm="1" md="1" lg="1" class="mt-0 mb-2 py-0">
                <m-button
                  fab
                  small
                  class="white--text float-start"
                  icon="mdi mdi-trash-can"
                  textButton=""
                  color="red"
                  action="deleteSyarat"
                  @deleteSyarat="deleteSyarat(index)"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" class="my-0 py-0">
                <v-select
                  outlined
                  dense
                  autocomplete="false"
                  v-model="term.j_syarat"
                  :items="itemSyarat"
                  item-text="nama"
                  item-value="id"
                  return-object
                  label="Pilih Jenis Syarat"
                  placeholder="Jenis Syarat"
                  @change="loadValSyarat(term.j_syarat)"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" class="my-0 py-0">
                <v-autocomplete
                  outlined
                  dense
                  multiple
                  autocomplete="false"
                  v-model="term.syarat"
                  :disabled="term.j_syarat ? false : true"
                  :items="itemPilihanSyarat"
                  item-text="keterangan"
                  item-value="value"
                  return-object
                  label="Pilih Syarat"
                  placeholder="Syarat"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-divider></v-divider>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p class="text-caption grey--text">*) Syarat <b>atau</b> digunakan untuk pilihan jenis syarat yang berbeda</p>
                <m-button id="atau" class="white--text float-end" textButton="atau" color="orange" action="addSyarat" @addSyarat="addSyarat"></m-button>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
    <!-- <FormGenerator autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation :field= "schema" :model="model" :data="data" @event="loadValSyarat"/> -->
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import FormGenerator from "@/components/FormGenerator";

//@group Jenis Kelas
export default {
  name: "jenis-kelas-form-syarat",
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FormGenerator
  },

  data() {
    return {
      title: null,
      isEdit: false,
      j_kelas: null,
      disableForm: false,
      alert: ALERT_INFO,
      term: {
        j_syarat: null,
        syarat: []
      },
      syarat: {},
      itemSyarat: [],
      itemPilihanSyarat: [],
      nama_syarat: null,
      syarats: [
        {
          k_syarat: null,
          pilihanSyarat: [],
          data: []
        }
      ]
    };
  },

  methods: {
    // @vuese
    // Membuka dialog tambah atau edit syarat pendafataran, jika terdapat objek maka dialog yang terbuka adalah untuk edit dan jika objek kosong maka dialog yang terbuka adalah untuk tambah (baru) syarat pendaftaran
    // @args objek syarat pendaftaran
    open(obj) {
      this.j_kelas = obj;
      this.loadSyarat();
      this.title = obj.keterangan;

      let x = this.$refs.dlgSyarat.open();
      this.$validator.reset();
      return x;
    },
    //@vuese
    //mengambil judul/jenis syarat
    loadSyarat() {
      return this.$store
        .dispatch("jenisKelas/getSyarat", {
          instansi_id: this.instansi_id,
          jenis_kelas_id: this.j_kelas.id
        })
        .then(res => {
          this.itemSyarat = res;
          this.disableForm = false;
        })
        .catch(e => e);
    },
    //@vuese
    //mengambil nilai dari masing-masing judul/jenis syarat
    // loadValSyarat(e) {
    //   if (e) {
    //     this.nama_syarat = e.nama
    //     return this.$store
    //       .dispatch("jenisKelas/getValSyarat", {
    //         instansi_id: this.instansi_id,
    //         jenis_syarat: e
    //       })
    //       .then(res => {
    //         if (e.nama == "ketuntasan" || e.nama == "dependensi") {
    //           this.itemPilihanSyarat = res.filter(s => s.id != this.j_kelas.id)
    //         }else{
    //           this.itemPilihanSyarat = res;
    //           this.itemPilihanSyarat = this.itemPilihanSyarat.filter(s => s.syarat.k_syarat == e.id)
    //           this.itemPilihanSyarat = this.itemPilihanSyarat[0].master_pilihan
    //         }
    //         this.disableForm = false;
    //       })
    //       .catch(e => e);
    //   }
    // },
    duplicateSyarat(o) {
      var valueArr = o.map(function(item) {
        return item.k_syarat;
      });
      var isDuplicate = valueArr.some(function(item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    },
    loadValSyarat(e, i) {
      if (e) {
        this.nama_syarat = e.nama;
        return this.$store
          .dispatch("jenisKelas/getValSyarat", {
            instansi_id: this.instansi_id,
            jenis_syarat: e
          })
          .then(res => {
            if (e.nama == "ketuntasan" || e.nama == "dependensi") {
              this.itemPilihanSyarat.push(res.filter(s => s.id != this.j_kelas.id));
              this.itemPilihanSyarat[i] = res.filter(s => s.id != this.j_kelas.id);
            } else if (e.nama == "belum_daftar") {
              this.itemPilihanSyarat.push(res);
              this.itemPilihanSyarat[i] = res;
            } else {
              this.syarats[i].pilihanSyarat = res;
              this.syarats[i].pilihanSyarat = this.syarats[i].pilihanSyarat.filter(s => s.syarat.k_syarat == e.id);
              this.itemPilihanSyarat.push(this.syarats[i].pilihanSyarat[0].master_pilihan);
              this.itemPilihanSyarat[i] = this.syarats[i].pilihanSyarat[0].master_pilihan;
            }
            this.disableForm = false;
          })
          .catch(e => e);
      }
    },
    //@vuese
    //Menambah form syarat
    addSyarat() {
      this.syarats.push({
        k_syarat: null,
        pilihanSyarat: [],
        data: []
      });
    },
    // addSyarat() {
    //   this.syarats.push(
    //     {
    //       k_syarat: null,
    //       data: [],
    //     }
    //   );
    // },
    // @vuese
    // Menghapus form syarat
    deleteSyarat(index) {
      this.syarats.splice(index, 1);
    },
    // @vuese
    // Menyimpan syarat pendaftaran
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          let n_syarat = this.nama_syarat;
          let key = "k_" + n_syarat;
          // if (this.syarats.length == 1) {
          if (!this.duplicateSyarat(this.syarats)) {
            return this.$store
              .dispatch("jenisKelas/setSyarat", {
                instansi_id: this.instansi_id,
                jenis_kelas_id: this.j_kelas.id,
                syarats: {
                  data_syarat: this.syarats,
                  is_aktif: 1
                },
                nama_syarat: key,
                syarat_url: n_syarat.replace(/[\s+_]/g, "-").toLowerCase()
              })
              .then(res => {
                this.$refs.dlgSyarat.resolve();
                return res;
              })
              .catch(e => e);
          } else {
            this.$error("Skema Syarat ATAU hanya dapat digunakan untuk Jenis Syarat yang berbeda");
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    j_kelas() {
      this.syarats = [
        {
          k_syarat: null,
          pilihanSyarat: [],
          data: []
        }
      ];
    }
  }
};
</script>
